import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { createPlaylist, addToPlaylist, editPlaylist, createPlaylistPersonal, editPlaylistPersonal, createPodcastTag, editPodcastTag } from '../../actions';
// import { Form } from '@ant-design/compatible';
// import '@ant-design/compatible/assets/index.css';
import { Button, Col, Form, Input, message, notification, Row, Upload } from 'antd';
import { createRandomLowercaseString, isAutoPlaylist, showTagName } from '../../lib/utils';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { setIsTyping } from '../../lib/fileUtils';
// const { Option } = Select;
const { TextArea } = Input;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
};
const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 24,
            offset: 8,
        },
    },
};

const openNotificationWithIcon = (type, message) => {
    notification[type]({
        message: message,
        description: 'Please try again.',
        duration: null
    });
};

class TagForm extends React.Component {
    constructor(props) {
        super(props);
        // const value = props.value || {};
        const { edit } = props;
        this.state = {
            type: 'private',
            loading: false,
            loadingImage: false,
            name: edit && props.tagName || '',
            description: edit && edit.playlistInfo && edit.playlistInfo.description || '',
            imageUrl: ''
            // playlistName: undefined
        };
    }

    handleSubmit = (values) => {
        // console.dir(values);
        const { userDetails, edit, editTagId, podcastDetails } = this.props;
        const { name, imageUrl } = this.state;
        // e.preventDefault();
        // this.props.form.validateFields((err, values) => {
        //     if (!err) {
        console.log('Received values of form: ', values);
        // this.setState({ loading: true });
        if (edit) {
            let newTagName = name;
            if (editTagId.includes('_u_')) {
                const tagNameTail = editTagId.split('_u_')[1];
                newTagName += '_u_' + tagNameTail;
            }
            this.props.editPodcastTag(editTagId, newTagName);
            this.props.callBackParent(true, newTagName);
        } else {
            console.dir(podcastDetails);
            const tagId = createRandomLowercaseString(5);
            this.props.callBackParent(true);
            const collectionsIdsMap = {};
            if (podcastDetails && podcastDetails.collectionId) {
                collectionsIdsMap[podcastDetails.collectionId] = true;
            }
            this.props.createPodcastTag(tagId, name, collectionsIdsMap);
            // this.setState({ playlistName: values.name });
        }
        //     }
        // });
    }

    validateName = (rule, value, callback) => {
        const charLength = 50;
        if (value && value.length > charLength) {
            callback(`Name should be less than ${charLength} characters`);
        } else {
            callback();
        }
    };
    // validateDescription = (rule, value, callback) => {
    //     const charLength = 160;
    //     if (value && value.length > charLength) {
    //         callback(`Description should be less than ${charLength} characters`);
    //     } else {
    //         callback();
    //     }
    // };

    // beforeUpload = (file) => {
    //     const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    //     if (!isJpgOrPng) {
    //         message.error('You can only upload JPG/PNG file!');
    //     }
    //     const isLt2M = file.size / 1024 / 1024 < 2;
    //     if (!isLt2M) {
    //         message.error('Image must be smaller than 2MB!');
    //     }
    //     return isJpgOrPng && isLt2M;
    // }

    // getBase64 = (img, callback) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('load', () => callback(reader.result));
    //     reader.readAsDataURL(img);
    //     console.dir(reader);
    // }
    // normFile = (e) => {
    //     console.log('Upload event:', e);
    //     e && this.getBase64(e.file.originFileObj, imageUrl =>
    //         this.setState({
    //             imageUrl,
    //             loadingImage: false,
    //         }),
    //     );
    //     if (Array.isArray(e)) {
    //         return e;
    //     }
    //     return e && e.fileList;
    // };
    // deleteImage = () => {
    //     this.setState({ imageUrl: '' });
    // }
    changeName = (e) => {
        setIsTyping();
        this.setState({ name: e.target.value });
    }
    // changeDescription = (e) => {
    //     this.setState({ description: e.target.value });
    // }

    render() {
        // console.dir(this.props);
        const { edit } = this.props;
        const { imageUrl, loadingImage, name, description } = this.state;
        console.log(edit);
        // const { getFieldDecorator } = this.props.form;
        // const playlistData = () => {
        // const initName = edit && edit.playlistInfo && edit.playlistInfo.name;
        // const initDesc = edit && edit.playlistInfo && edit.playlistInfo.description;
        const initImage = edit && edit.playlistInfo && edit.playlistInfo.imageName;
        // }
        // const WrappedPlaylistForm = Form.create({ name: 'normal_login' })(PlaylistForm);
        // console.dir(imageUrl);
        const fields = [
            {
                "name": [
                    "name"
                ],
                "value": name
            }, {
                "name": [
                    "description"
                ],
                "value": description
            }
        ];

        // const uploadButton = (
        //     <div>
        //         {loadingImage ? <LoadingOutlined /> : <PlusOutlined />}
        //         <div style={{ marginTop: 8 }}>{initImage ? 'Replace Existing Image' : 'Upload Image (Optional)'}</div>
        //     </div>
        // );

        return (
            <Form onFinish={this.handleSubmit} fields={fields} className="login-form">
                <Row style={{ width: '100%' }}>
                    <Col xs={24} sm={24} md={24} xl={24}>
                        <Form.Item {...formItemLayout} name="name"
                            rules={[{ required: true, message: 'Please enter a name for the Collection.' }, { validator: this.validateName }]}>
                            {/* {getFieldDecorator('name', {
                        initialValue: initName,
                        rules: [{ required: true, message: 'Please enter a name for the playlist.' }, { validator: this.validateName }],
                    })( */}
                            <Input placeholder="Collection Name" onChange={this.changeName} />
                            {/* )} */}
                        </Form.Item>
                    </Col>
                </Row>
                {/* {imageUrl && <p>By proceeding, you agree to give Accelerated access to the image you choose to upload. Please make sure you have the right to upload this image.</p>} */}

                <Form.Item {...tailFormItemLayout}>
                    <Button type="primary" loading={this.state.loading} htmlType="submit">
                        {(!edit) && 'Create Collection'}
                        {edit && 'Edit Collection'}
                    </Button>
                    {/* <Button type="primary" htmlType="submit" className="login-form-button">
                        Create Playlist
                    </Button> */}
                </Form.Item>
                <style jsx>
                    {`
            // .login-form {
            //     max-width: 300px;
            //   }
            // .login-form-forgot {
            //     float: right;
            //   }
            //   .login-form-button {
            //     width: 100%;
            //   }
          `}
                </style>
            </Form>
        );
    }
}

TagForm.defaultProps = {
    edit: false
}

TagForm.propTypes = {
    edit: PropTypes.bool,
    editTagId: PropTypes.string,
    tagName: PropTypes.string,
    userDetails: PropTypes.object,
    podcastDetails: PropTypes.object,
    form: PropTypes.object,
    userPlaylists: PropTypes.object,
    getFieldDecorator: PropTypes.func,
    createPlaylistPersonal: PropTypes.func,
    editPlaylistPersonal: PropTypes.func,
    createPodcastTag: PropTypes.func,
    editPodcastTag: PropTypes.func,
    callBackParent: PropTypes.func,
}

const WrappedTagForm = TagForm; // Form.create({ name: 'playlist_form' })(TagForm);
// ReactDOM.render(<WrappedNormalLoginForm />, mountNode);

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        userPlaylists: state.userPlaylists
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createPodcastTag: bindActionCreators(createPodcastTag, dispatch),
        editPodcastTag: bindActionCreators(editPodcastTag, dispatch),
        editPlaylistPersonal: bindActionCreators(editPlaylistPersonal, dispatch),
        addToPlaylist: bindActionCreators(addToPlaylist, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(WrappedTagForm);